import React from "react";
import SaleReturnHeader from "./SaleReturnHeader";
import SaleReturnList from "./SaleReturnList";

const SaleReturn = () => {
  return (
    <>
      <div className="content-header">
        <div className="container-fluid px-2">
          <div className="row mb-2">
            <div className="col-sm-12">
              <ol className="breadcrumb">
                <li className="breadcrumb-item active">Sale Return</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <section className="content" style={{ paddingBottom: "1.5rem" }}>
        <div className="container-fluid px-4">
          <SaleReturnHeader />
          <SaleReturnList />
        </div>
      </section>
    </>
  );
};

export default SaleReturn;